/** Maps construction material records between API snake_case and form fields. */

const CAMEL_TO_SNAKE: Record<string, string> = {
  name: 'name',
  category: 'category',
  subcategory: 'subcategory',
  manufacturer_brand: 'manufacturer_brand',
  system_code: 'system_code',
  region: 'region',
  strength: 'strength',
  density: 'density',
  size: 'size',
  length: 'length',
  width: 'width',
  thickness: 'thickness',
  unit: 'unit',
  quantity: 'qty',
  unit_cost: 'unit_cost',
  total_cost: 'total_cost',
  location: 'location',
  leadTime: 'lead_time',
  carbon_footprint: 'carbon_footprint',
  recyclability: 'recyclability',
  building_type: 'building_type',
  use_case: 'use_case',
  certifications: 'certifications',
  testing_method: 'testing_method',
  tools: 'tools',
  method: 'method',
  countries: 'countries',
  regions: 'regions',
  durability: 'durability',
  fire_resistance: 'fire_resistance',
  brand: 'brand',
  model: 'model',
};

function readValue(raw: Record<string, unknown>, camel: string, snake: string): unknown {
  if (raw[camel] !== undefined && raw[camel] !== null && raw[camel] !== '') {
    return raw[camel];
  }
  if (raw[snake] !== undefined && raw[snake] !== null && raw[snake] !== '') {
    return raw[snake];
  }
  return undefined;
}

/** Normalize GET construction-materials payload for reactive form patchValue. */
export function materialMasterToForm(raw: Record<string, unknown> | null | undefined): Record<string, unknown> {
  if (!raw) {
    return {};
  }

  const form: Record<string, unknown> = {};

  for (const [camel, snake] of Object.entries(CAMEL_TO_SNAKE)) {
    const value = readValue(raw, camel, snake);
    if (value !== undefined) {
      form[camel] = value;
    }
  }

  return form;
}

/** Build POST/PUT body aligned with import template and API snake_case. */
export function materialFormToApi(form: Record<string, unknown>): Record<string, unknown> {
  const payload: Record<string, unknown> = {};

  for (const [camel, snake] of Object.entries(CAMEL_TO_SNAKE)) {
    const value = form[camel];
    if (value !== undefined && value !== null && value !== '') {
      payload[snake] = value;
    }
  }

  return payload;
}
